import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Layout from "../components/Layout";

import Footer from "../components/Footer";
import Header from "../components/Header";

import applyCustomer from "../assets/images/applyCustomer.jpg";
import applyAgent from "../assets/images/Agent.jpg";
import CarouselSection from "../components/carousel";

const Apply = () => {
  const [customerMobile, setCustomerMobile] = useState("");
  const [agentMobile, setAgentMobile] = useState("");
  const [check, setCheck] = useState(false);
  const [disableCustomer, setDisableCustomer] = useState(true);
  const [disableAgent, setDisableAgent] = useState(true);

  useEffect(() => {
    check && agentMobile.length === 10 && setDisableAgent(false);
  }, [check]);

  useEffect(() => {
    customerMobile.length === 10 && setDisableCustomer(false);
  }, [customerMobile]);

  useEffect(() => {
    check && agentMobile.length === 10 && setDisableAgent(false);
  }, [agentMobile]);

  const handleCustomerChange = (e) => {
    setCustomerMobile(e.target.value);
  };

  const handleAgentChange = (e) => {
    setAgentMobile(e.target.value);
  };

  return (
    <Layout>
      <Header />
      <header
        id="customer"
        className="masthead"
        style={{
          backgroundImage: `url(${applyCustomer})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="overlay overlay2" />
        <div className="container d-flex h-100 align-items-center justify-content-center">
          <div className="headerCard text-center">
            <h1 className="m-0">be part of the solution...be a customer.</h1>
            <form
              action="https://getform.io/f/f6b7119c-2abc-41fe-9bb9-b384068bd7a5"
              method="POST"
            >
              <input
                className="input mt-5"
                type="number"
                value={customerMobile}
                onChange={handleCustomerChange}
                name="phone"
                placeholder="enter mobile phone number"
              />
              <input
                className="input"
                type="hidden"
                name="Enquire for"
                value="customer"
              />
              <button
                type="submit"
                disabled={disableCustomer}
                className="btn btn-primary headerButton mt-4"
              >
                become a customer
              </button>
            </form>
          </div>
        </div>
      </header>

      <section className="review-section">
        <h3 className="text-center mb-lg-5 font-weight-bold">reviews</h3>
        <CarouselSection type="customer" />
      </section>

      <header
        id="agent"
        className="masthead"
        style={{
          backgroundImage: `url(${applyAgent})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="overlay overlay2" />
        <div className="container d-flex h-100 align-items-center justify-content-center">
          <div className="headerCard text-center">
            <h1 className="m-0">freedom + responsibility = agent</h1>
            <form
              action="https://getform.io/f/f6b7119c-2abc-41fe-9bb9-b384068bd7a5"
              method="POST"
            >
              <input
                className="input"
                type="number"
                name="phone"
                value={agentMobile}
                onChange={handleAgentChange}
                placeholder="enter mobile phone number"
              />
              <input
                className="input"
                type="hidden"
                name="Enquire for"
                value="agent"
              />
              <div className="d-flex align-items-center justify-content-center mt-4 mb-4">
                <input
                  checked={check}
                  type="checkbox"
                  className="checkbox"
                  onChange={() => setCheck(true)}
                />
                <p className="m-0 pl-2">i agree to the terms of use</p>
              </div>
              <button
                disabled={disableAgent}
                type="submit"
                className="btn btn-primary headerButton mt-3"
                id="terms"
              >
                apply to be an agent
              </button>
            </form>
          </div>
        </div>
      </header>

      <section className="review-section">
        <h3 className="text-center mb-lg-5 font-weight-bold">reviews</h3>
        <CarouselSection type="agent" />
      </section>

      <Footer />
    </Layout>
  );
};

export default Apply;
